export default function newsItemsCategories() {
  return {
    init() {
      this.filter_els = this.$el.querySelectorAll('[data-js-selector="news-items-filter-button"]');
    },

    activateFilter(el) {
      this.filter_els.forEach((filter) => {
        filter.classList.remove('news-items__filter-button--active');
      });
      el.classList.add('news-items__filter-button--active');
    },

    filters: {
      ['@click']() {
        const filterButton = this.$event.target.closest('[data-js-selector="news-items-filter-button"]');

        if (!filterButton || !this.$el.contains(filterButton)) return;

        this.activateFilter(filterButton);
        // Clear focus after click to prevent sticky focus-driven button styling with Turbo updates.
        filterButton.blur();
      },
    },
  };
}
